import { Injectable, Inject } from '@angular/core';
import { DEFAULT_TIMEZONE } from '@nx-ng/constants/timezone';
import { addLeadTimeInDays, getNowUTCDate } from '@nx-ng/util';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { utcToZonedTime } from 'date-fns-tz';

@Injectable({
  providedIn: 'root',
})
export class SwiftMinDateService {
  constructor(@Inject(I18NEXT_SERVICE) private i18n: ITranslationService) {}

  getMinDateForNewSwiftCard(): Date {
    const earliestDate = addLeadTimeInDays(
      getNowUTCDate(),
      Number.parseInt(
        this.i18n.t('swift_new_card_lead_time_in_days', { ns: 'config' })
      )
    );

    return utcToZonedTime(earliestDate, DEFAULT_TIMEZONE);
  }

  getMinDateForExistingSwiftCard(): Date {
    return utcToZonedTime(getNowUTCDate(), DEFAULT_TIMEZONE);
  }
}
